
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.696","height":"24.696","viewBox":"0 0 24.696 24.696"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_5","data-name":"Group 5","transform":"translate(-99.857 -132.935)"}},[_c('circle',{attrs:{"id":"Ellipse_3","data-name":"Ellipse 3","cx":"12.348","cy":"12.348","r":"12.348","transform":"translate(99.857 132.935)","fill":"#fff"}}),_c('g',{attrs:{"id":"Group_4","data-name":"Group 4"}},[_c('g',{attrs:{"id":"Group_3","data-name":"Group 3"}},[_c('path',{attrs:{"id":"Path_3","data-name":"Path 3","d":"M116.038,140.612a.849.849,0,1,0,.849.849A.849.849,0,0,0,116.038,140.612Z","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_4","data-name":"Path 4","d":"M112.265,141.7a3.565,3.565,0,1,0,3.565,3.565A3.57,3.57,0,0,0,112.265,141.7Zm0,5.849a2.284,2.284,0,1,1,2.284-2.284A2.286,2.286,0,0,1,112.265,147.55Z","fill":"#fd7e14"}}),_c('path',{attrs:{"id":"Path_5","data-name":"Path 5","d":"M115.1,152.506h-5.78a4.354,4.354,0,0,1-4.349-4.349v-5.781a4.354,4.354,0,0,1,4.349-4.349h5.78a4.355,4.355,0,0,1,4.35,4.349v5.781A4.355,4.355,0,0,1,115.1,152.506Zm-5.78-13.117a2.99,2.99,0,0,0-2.987,2.987v5.781a2.99,2.99,0,0,0,2.987,2.986h5.78a2.99,2.99,0,0,0,2.987-2.986v-5.781a2.99,2.99,0,0,0-2.987-2.987Z","fill":"#fd7e14"}})])])])])
          )
        }
      }
    